import { Params } from '@angular/router';
import { DsModalColorVariant, Icons } from '@levelaccess/design-system';

import { IRequiredSecurity } from '../../../../shared/interfaces/security.interface';
import { SharedCommonUtility } from '../../../../shared/utils/common.utility';
import { RequiredSecurities } from '../../../../shared/constants/required-securities';
import { Api } from '../../../../shared/constants/api';
import { FeatureFlagCollection, FeatureFlagName, revertFlag } from '../../../../shared/interfaces/feature-flag.interface';
import { SecurityUtility } from '../../../../shared/utils/security.utility';
import { IUserServerResponse } from '../../../../shared/interfaces/user.interface';
import { $user } from '../../../../shared/constants/user';
import { $securityGroup } from '../../../../shared/constants/security-group';
import { ISecurityGroup } from '../../../../shared/interfaces/security-group.interface';
import { PackageNames } from '../../../../shared/constants/packaging';
import { ExternalLinkService } from '../external-link.service';
import { AppConfigService } from '../app-config.service';
import { FeatureFlagService } from '../feature-flag/feature-flag.service';
import { FeatureManagementService } from '../feature-management/feature-management.service';
import { AcademyService } from '../academy.service';
import { LinkedPropertyUtility } from '../../../../shared/utils/linked-property.utility';

export enum NavigationItem {
  organization_dashboard = 'organization_dashboard',
  organization_portfolio = 'organization_portfolio',

  program_dashboard = 'program_dashboard',
  program_portfolio = 'program_portfolio',
  custom_reports = 'custom_reports',

  organization_settings = 'organization_settings',
  organization_settings_users = 'organization_settings_users',
  organization_settings_all_users = 'organization_settings_all_users',
  organization_settings_unassigned_users = 'organization_settings_unassigned_users',
  organization_settings_group_mappings = 'organization_settings_group_mappings',
  organization_settings_user_groups = 'organization_settings_user_groups',
  organization_settings_staff_groups = 'organization_settings_staff_groups',
  organization_settings_rule_libraries = 'organization_settings_rule_libraries',
  organization_settings_severities = 'organization_settings_severities',
  organization_settings_details = 'organization_settings_details',

  evaluations = 'evaluations',
  manual_evaluations = 'manual_evaluations',
  mobile_manual_evaluations = 'mobile_manual_evaluations',
  design_evaluations = 'design_evaluations',

  tools_and_integrations = 'tools_and_integrations',
  issue_tracking = 'issue_tracking',
  tools_and_extensions = 'tools_and_extensions',
  sdks = 'sdks',
  api = 'api',
  connected_apps = 'connected_apps',
  webhooks = 'webhooks',
  scim = 'scim',
  userway = 'userway',

  administration = 'administration',
  administration_tenants = 'administration_tenants',
  administration_organizations = 'administration_organizations',
  administration_my_organizations = 'administration_my_organizations',
  administration_all_organizations = 'administration_all_organizations',
  administration_users = 'administration_users',
  administration_global_users = 'administration_global_users',
  administration_internal_users = 'administration_internal_users',
  administration_admin_groups = 'administration_admin_groups',

  internal_use_only = 'internal_use_only',
  master_library = 'master_library',
  active_scans = 'active_scans',
  translations = 'translations',

  workspace = 'workspace',
  workspace_dashboard = 'workspace_dashboard',
  websites_and_apps = 'websites_and_apps',
  websites_and_apps_portfolio = 'websites_and_apps_portfolio',
  websites_and_apps_overview = 'websites_and_apps_overview',
  websites_and_apps_activity = 'websites_and_apps_activity',
  websites_and_apps_findings = 'websites_and_apps_findings',
  websites_and_apps_monitoring = 'websites_and_apps_monitoring',
  websites_and_apps_scans = 'websites_and_apps_scans',
  websites_and_apps_scans_mobile = 'websites_and_apps_scans_mobile',
  websites_and_apps_scans_mobile_table = 'websites_and_apps_scans_mobile_table',
  websites_and_apps_mobile_scans = 'websites_and_apps_mobile_scans',
  websites_and_apps_mobile_scans_page_scans = 'websites_and_apps_mobile_scans_page_scans',
  websites_and_apps_mobile_testing_emulator = 'websites_and_apps_mobile_testing_emulator',
  websites_and_apps_mobile_testing_emulator_app = 'websites_and_apps_mobile_testing_emulator_app',
  websites_and_apps_mobile_testing_emulator_scans = 'websites_and_apps_mobile_testing_emulator_scans',
  websites_and_apps_monitoring_settings = 'websites_and_apps_monitoring_settings',
  websites_and_apps_scans_page_scans = 'websites_and_apps_scans_page_scans',
  websites_and_apps_scans_components = 'websites_and_apps_scans_components',
  websites_and_apps_scans_user_flows = 'websites_and_apps_scans_user_flows',
  websites_and_apps_scan_rules = 'websites_and_apps_scan_rules',
  websites_and_apps_scan_tags = 'websites_and_apps_scan_tags',
  websites_and_apps_pages = 'websites_and_apps_pages',
  websites_and_apps_mobile_screens = 'websites_and_apps_mobile_screens',
  websites_and_apps_manual_evaluations = 'websites_and_apps_manual_evaluations',
  websites_and_apps_manual_evaluations_table = 'websites_and_apps_manual_evaluations_table',
  websites_and_apps_manual_evaluations_requests = 'websites_and_apps_manual_evaluations_requests',
  websites_and_apps_mobile_manual_evaluations = 'websites_and_apps_mobile_manual_evaluations',
  websites_and_apps_settings = 'websites_and_apps_settings',
  websites_and_apps_settings_consolidated = 'websites_and_apps_settings_consolidated',
  websites_and_apps_settings_monitoring = 'websites_and_apps_settings_monitoring',
  websites_and_apps_automated_user_flows = 'websites_and_apps_automated_user_flows',
  websites_and_apps_guided_user_flows = 'websites_and_apps_guided_user_flows',
  websites_and_apps_settings_components = 'websites_and_apps_settings_components',
  websites_and_apps_settings_environments = 'websites_and_apps_settings_environments',
  websites_and_apps_settings_scan_rules = 'websites_and_apps_settings_scan_rules',
  websites_and_apps_settings_scan_tags = 'websites_and_apps_settings_scan_tags',
  websites_and_apps_settings_pages = 'websites_and_apps_settings_pages',
  websites_and_apps_settings_mobile_screens = 'websites_and_apps_settings_mobile_screens',
  websites_and_apps_environments = 'websites_and_apps_environments',
  workspace_design_evaluations = 'workspace_design_evaluations',
  workspace_settings = 'workspace_settings',
  workspace_policies = 'workspace_policies',
  workspace_details = 'workspace_details',
  workspace_settings_consolidated = 'workspace_settings_consolidated',
  pdf = 'pdf',
  files = 'files',

  profile = 'profile',
  logout = 'logout',

  projects_and_tasks = 'projects_and_tasks',
  projects = 'projects',
  my_tasks = 'my_tasks',

  help = 'help',
  old_help = 'old_help',
  help_submit_ticket = 'help_submit_ticket',
  help_search_knowledge = 'help_search_knowledge',
  help_product_support = 'help_product_support',
  help_help_center = 'help_help_center',
  help_submit_feedback = 'help_submit_feedback',

  service_request = 'service_request',
  service_request_email_consultation = 'service_request_email_consultation',
  service_request_manual_evaluation = 'service_request_manual_evaluation',
  service_request_validation_testing = 'service_request_validation_testing',
  service_request_view_all_services = 'service_request_view_all_services',
  service_request_cuet_evaluation = 'service_request_cuet_evaluation',

  notifications = 'notifications',
  academy = 'academy',
  workspace_switcher = 'workspace_switcher',
  website_app_selector = 'website_app_selector',

  common_findings = 'common_findings',
  level_ci = 'level_ci',
  nav_switch = 'nav_switch',
}

export enum NavigationContext {
  tenant = 'tenant',
  workspace = 'workspace',
  digitalProperty = 'digitalProperty',
}

export function getNavigationContextTranslationKey(contextItem: INavigationContextItem): string {
  switch (contextItem.type) {
    case NavigationContext.tenant:
      return 'organization';
    case NavigationContext.workspace:
      return 'workspace';
    case NavigationContext.digitalProperty:
      return 'digital_asset';
    default:
      return 'program';
  }
}

export enum NavigationGroup {
  organization = 'organization',
  workspace = 'workspace',
  digital_asset = 'digital_asset',
  find_and_fix = 'find_and_fix',
  automated_tests = 'automated_tests',
  expert_audits = 'expert_audits',
  manage = 'manage',
  support = 'support',
}

export interface INavigationContextItem {
  id: string;
  type: NavigationContext;
  label: string;
  icon?: Icons;
  routerLink?: string;
}

// Use to expose the link as available to AI chat
export interface IAiChatNav {
  key: string;
  description: string;
  requiresLinkedPropertyData?: boolean;
}

export interface INavMenuItem {
  id: NavigationItem;
  label?: string;
  labelFn?: (args: INavItemLabelArgs) => string;
  ariaLabel?: string;
  /** Translation key of a short chip shown after the label, e.g. to flag a new page. */
  badgeLabel?: string;
  context?: NavigationContext;
  group?: NavigationGroup;
  isAvailable?: boolean;
  isAvailableFn?: INavMenuItemIsAvailableFn;
  isHiddenFn?: INavMenuItemIsAvailableFn;
  displayedOutsideOfNavbar?: boolean;
  isActive?: boolean;
  isHidden?: boolean;
  overrideRouterLink?: string;
  routerLink?: string;
  routerLinkFn?: (args: INavItemRouterLinkArgs) => string;
  externalLink?: string;
  externalLinkFn?: (externalLinkService: ExternalLinkService) => string;
  external?: boolean;
  onClick?: () => void;
  onClickFn?: (data: INavItemOnClickArgs) => () => void;
  requiredSecurity?: IRequiredSecurity | IRequiredSecurity[];
  children?: INavMenuItem[];
  parent?: INavMenuItem;
  iconName?: Icons;
  featureFlag?: string;
  tenantlessOnly?: boolean;
  tenantOnly?: boolean;
  mobileOnly?: boolean;
  mobileModalColorVariant?: DsModalColorVariant;
  restrictByWorkspace?: boolean;
  filters?: INavMenuItemFilter[];
  aiChatNav?: IAiChatNav;
}

export interface INavItemFilterArgs {
  isVerticalNavigationEnabled: boolean;
}
export interface INavItemLabelArgs {
  isVerticalNavigationEnabled: boolean;
  featureFlagService: FeatureFlagService;
}

export interface INavItemIsAvailableArgs {
  user: IUserServerResponse;
  packageName: PackageNames;
  isAcademyAvailable: boolean;
  isWebDp: boolean;
  isMobileDp: boolean;
  isAiEnabled: boolean;
  isScimEnabled: boolean;
  appConfigService: AppConfigService;
  featureFlagService: FeatureFlagService;
  featureManagementService: FeatureManagementService;
}

export interface INavItemRouterLinkArgs {
  queryParams: Params;
  featureFlagService: FeatureFlagService;
}

export interface INavItemOnClickArgs {
  academyService: AcademyService;
}

export interface IWorkspacePermission {
  activeMenuItem: INavMenuItem;
  workspacesMenuItem: INavMenuItem;
  workspaceId: string;
  digitalPropertyId: string;
  hasAccess?: boolean;
}

export type INavMenuItemFilter = (args: INavItemFilterArgs) => boolean;

export function verticalNavigationFilter(enabled: boolean): INavMenuItemFilter {
  return (args: INavItemFilterArgs): boolean => {
    return Boolean(args.isVerticalNavigationEnabled) === enabled;
  };
}

export type INavMenuItemIsAvailableFn = (args: INavItemIsAvailableArgs) => boolean;

export function isWebDpAvailable(args: INavItemIsAvailableArgs): boolean {
  return args.isWebDp;
}

export function isMobileDpAvailable(args: INavItemIsAvailableArgs): boolean {
  return args.isMobileDp;
}

function getConsolidatedDigitalAssetSettingsLink(
  pathSegment: string,
  { featureFlagService }: INavItemRouterLinkArgs,
): string | undefined {
  if (featureFlagService.variation(FeatureFlagCollection.consolidateSettings, false)) {
    return `/${Api.settings}/${Api.digitalAssetSettings}/${pathSegment}`;
  }

  return undefined;
}

function digitalAssetSettingsRouterLinkFn(
  legacyRouterLink: string,
  consolidatedPathSegment: string,
): (args: INavItemRouterLinkArgs) => string {
  return (args: INavItemRouterLinkArgs): string => {
    const consolidatedLink: string | undefined = getConsolidatedDigitalAssetSettingsLink(consolidatedPathSegment, args);
    return consolidatedLink ?? legacyRouterLink;
  };
}

function userHasRequiredSecurity(user: IUserServerResponse, requiredSecurity: IRequiredSecurity): boolean {
  if (SharedCommonUtility.isNullish(user?.[$user.securitySet])) {
    return false;
  }

  return SecurityUtility.hasAccess(user[$user.securitySet], requiredSecurity.functionalActions);
}

export function isDigitalAssetSettingsConsolidatedAvailable(args: INavItemIsAvailableArgs): boolean {
  const { featureFlagService, packageName, isWebDp, isMobileDp, user } = args;
  const isAuditPackage: boolean = packageName === PackageNames.Audit;
  const hasRequiredSecurity = (requiredSecurity: IRequiredSecurity): boolean => userHasRequiredSecurity(user, requiredSecurity);

  return [
    isWebDp && hasRequiredSecurity(RequiredSecurities.GR_Monitoring_Create_Update),
    featureFlagService.variation(FeatureFlagCollection.userFlows, false) &&
      isWebDp &&
      hasRequiredSecurity(RequiredSecurities.Automated_Flows_Read),
    featureFlagService.variation(FeatureFlagCollection.userFlowsGuided, false) &&
      isWebDp &&
      hasRequiredSecurity(RequiredSecurities.Automated_Flows_Read),
    isWebDp && hasRequiredSecurity(RequiredSecurities.Component_Matching_Read),
    hasRequiredSecurity(RequiredSecurities.Environment_Read),
    isWebDp && hasRequiredSecurity(RequiredSecurities.Evaluation_Rules_Read),
    isWebDp && hasRequiredSecurity(RequiredSecurities.Scan_Tags_Read),
    !isAuditPackage && isWebDp && hasRequiredSecurity(RequiredSecurities.Pages_Read),
    !isAuditPackage &&
      isMobileDp &&
      featureFlagService.variation(FeatureFlagCollection.flawMatchingMobile, false) &&
      hasRequiredSecurity(RequiredSecurities.AT_Mobile_Scans_Read),
  ].some((isAvailable: boolean): boolean => isAvailable);
}

export function isSSOAvailable(args: INavItemIsAvailableArgs): boolean {
  return args.appConfigService.isUsingExternalIdp();
}

export function isScimAvailable(args: INavItemIsAvailableArgs): boolean {
  return args.isScimEnabled;
}

export function isMcpOauthAvailable(args: INavItemIsAvailableArgs): boolean {
  return args.featureFlagService.variation(FeatureFlagCollection.mcpOauth, false);
}

export function isPlatformWidgetTabHidden(args: INavItemIsAvailableArgs): boolean {
  return args.featureFlagService.variation(FeatureFlagCollection.platformWidgetTabHidden);
}

export function isAnyAvailableFn(isAvailableFns: INavMenuItemIsAvailableFn[]): INavMenuItemIsAvailableFn {
  return (args: INavItemIsAvailableArgs): boolean => {
    return isAvailableFns.some((isAvailableFn: INavMenuItemIsAvailableFn) => isAvailableFn(args));
  };
}

export function isManualEvaluationsAvailable(args: INavItemIsAvailableArgs): boolean {
  return args.user?.groups?.some((group: ISecurityGroup): boolean => group[$securityGroup.isStaffGroup] === true) ?? false;
}

export function isFmeFlagOn(featureFlagName: FeatureFlagName): INavMenuItemIsAvailableFn {
  return (args: INavItemIsAvailableArgs): boolean => args.featureManagementService.isOn(featureFlagName)();
}

/** Staff-only mobile manual evaluations item: the FME flag is on and the user is in a staff group. */
export function isStaffMobileManualEvaluationsAvailable(args: INavItemIsAvailableArgs): boolean {
  return isFmeFlagOn(FeatureFlagName.mobileManualEvaluations)(args) && isManualEvaluationsAvailable(args);
}

export function applyIsAvailableFnOnFeatureFlag(
  featureFlag: FeatureFlagCollection,
  fallback: boolean,
  isAvailableFn: INavMenuItemIsAvailableFn,
): INavMenuItemIsAvailableFn {
  return (args: INavItemIsAvailableArgs): boolean => {
    if (args.featureFlagService.variation(featureFlag)) {
      return isAvailableFn(args);
    }
    return fallback;
  };
}

export const NavigationRoutingTree: INavMenuItem[] = SharedCommonUtility.freezeDeep<INavMenuItem[]>([
  {
    id: NavigationItem.evaluations,
    label: 'manual_evaluations_navigation_item_label',
    iconName: Icons.UniversalAccess,
    filters: [verticalNavigationFilter(false)],
    children: [
      {
        id: NavigationItem.manual_evaluations,
        label: 'manual_evaluations_navigation_item_label',
        requiredSecurity: RequiredSecurities.MT_Manual_Audits_Read,
        routerLink: `/${Api.admin}/${Api.manual_audit}`,
        isAvailableFn: applyIsAvailableFnOnFeatureFlag(
          FeatureFlagCollection.changeHowManualEvalsAreManagedByClients,
          true,
          isManualEvaluationsAvailable,
        ),
      },
      {
        id: NavigationItem.mobile_manual_evaluations,
        label: 'mobile_manual_evaluations_navigation_item_label',
        requiredSecurity: RequiredSecurities.MT_Mobile_Manual_Evaluations_Read_No_Entity_Level,
        routerLink: `/${Api.admin}/${Api.manual_audit}/${Api.mobile}`,
        isAvailableFn: isStaffMobileManualEvaluationsAvailable,
      },
      {
        id: NavigationItem.design_evaluations,
        label: 'label_design_review_title',
        requiredSecurity: RequiredSecurities.DE_Administration_Read,
        routerLink: `/${Api.designReviews}`,
      },
    ],
  },
  {
    id: NavigationItem.evaluations,
    label: 'evaluations',
    iconName: Icons.UserMagnifyingGlass,
    group: NavigationGroup.manage,
    context: NavigationContext.tenant,
    filters: [verticalNavigationFilter(true)],
    children: [
      {
        id: NavigationItem.manual_evaluations,
        label: 'manual_evaluations_navigation_item_label',
        requiredSecurity: RequiredSecurities.MT_Manual_Audits_Read,
        routerLink: `/${Api.admin}/${Api.manual_audit}`,
        tenantOnly: true,
        isAvailableFn: applyIsAvailableFnOnFeatureFlag(
          FeatureFlagCollection.changeHowManualEvalsAreManagedByClients,
          true,
          isManualEvaluationsAvailable,
        ),
      },
      {
        id: NavigationItem.mobile_manual_evaluations,
        label: 'mobile_manual_evaluations_navigation_item_label',
        requiredSecurity: RequiredSecurities.MT_Mobile_Manual_Evaluations_Read_No_Entity_Level,
        routerLink: `/${Api.admin}/${Api.manual_audit}/${Api.mobile}`,
        tenantOnly: true,
        isAvailableFn: isStaffMobileManualEvaluationsAvailable,
      },
      {
        id: NavigationItem.design_evaluations,
        label: 'label_design_review_title',
        requiredSecurity: RequiredSecurities.DE_Administration_Read,
        tenantOnly: true,
        routerLink: `/${Api.designReviews}`,
      },
    ],
  },
  {
    id: NavigationItem.organization_settings,
    label: 'organization_settings_dropdown_menu_item_label',
    group: NavigationGroup.manage,
    iconName: Icons.Gear,
    context: NavigationContext.tenant,
    children: [
      {
        id: NavigationItem.organization_settings_users,
        label: 'users',
        context: NavigationContext.tenant,
        requiredSecurity: RequiredSecurities.UM_User_Administration_Read_No_Entity_Level,
        tenantOnly: true,
        children: [
          {
            id: NavigationItem.organization_settings_all_users,
            label: 'users',
            context: NavigationContext.tenant,
            routerLink: `/${Api.admin}/${Api.userManagement}/${Api.users}`,
            requiredSecurity: RequiredSecurities.UM_User_Administration_Read_No_Entity_Level,
            tenantOnly: true,
            displayedOutsideOfNavbar: true,
          },
          {
            id: NavigationItem.organization_settings_unassigned_users,
            label: 'unassigned_users',
            context: NavigationContext.tenant,
            routerLink: `/${Api.admin}/${Api.userManagement}/${Api.unassigned_users}`,
            requiredSecurity: RequiredSecurities.TI_SCIM_Config_Read,
            tenantOnly: true,
            displayedOutsideOfNavbar: true,
            featureFlag: FeatureFlagCollection.scimFunctionality,
            isAvailableFn: isScimAvailable,
          },
          {
            id: NavigationItem.organization_settings_group_mappings,
            label: 'group_mappings',
            context: NavigationContext.tenant,
            routerLink: `/${Api.admin}/${Api.userManagement}/${Api.group_mappings}`,
            requiredSecurity: RequiredSecurities.TI_SCIM_Config_Read,
            tenantOnly: true,
            displayedOutsideOfNavbar: true,
            featureFlag: FeatureFlagCollection.scimGroupsSupport,
            isAvailableFn: isScimAvailable,
          },
        ],
      },
      {
        id: NavigationItem.organization_settings_user_groups,
        label: 'user_groups',
        requiredSecurity: RequiredSecurities.User_Groups_Read,
        routerLink: `/${Api.admin}/${Api.userGroups}`,
        tenantOnly: true,
      },
      {
        id: NavigationItem.organization_settings_staff_groups,
        label: 'staff_groups',
        requiredSecurity: RequiredSecurities.Staff_Groups_Read,
        routerLink: `/${Api.admin}/${Api.staffGroups}`,
        tenantOnly: true,
      },
      {
        id: NavigationItem.organization_settings_rule_libraries,
        label: 'rule_libraries',
        requiredSecurity: RequiredSecurities.Tenant_Rule_Library_Read,
        routerLink: `/${Api.custom_audit_rules}`,
        tenantOnly: true,
      },
      {
        id: NavigationItem.organization_settings_severities,
        label: 'severities',
        requiredSecurity: RequiredSecurities.CustomSeverities_Read,
        routerLink: `/${Api.custom_severities}`,
        tenantOnly: true,
      },
      {
        id: NavigationItem.organization_settings_details,
        label: 'organization_details',
        requiredSecurity: RequiredSecurities.Organization_Details_Read,
        routerLink: `/${Api.organization_details}`,
        tenantOnly: true,
      },
    ],
  },
  {
    id: NavigationItem.tools_and_integrations,
    label: 'tools_and_integrations',
    group: NavigationGroup.manage,
    iconName: Icons.ScrewdriverWrench,
    context: NavigationContext.tenant,
    children: [
      {
        id: NavigationItem.issue_tracking,
        label: 'issue_tracking_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.issue_tracking}`,
        requiredSecurity: RequiredSecurities.TI_Issue_Tracking_Basic_Read,
      },
      {
        id: NavigationItem.tools_and_extensions,
        label: 'tools_and_extensions_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.test_automation}`,
        requiredSecurity: RequiredSecurities.TI_Tools_Extensions_Read_No_Entity_Level,
      },
      {
        id: NavigationItem.sdks,
        label: 'sdks_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.testAutomationSdks}`,
        requiredSecurity: RequiredSecurities.SDK_Read_No_Entity_Level,
      },
      {
        id: NavigationItem.api,
        label: 'api_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.api}`,
        requiredSecurity: RequiredSecurities.API_Keys_Read,
      },
      {
        // No requiredSecurity: every user can manage their own connected apps.
        id: NavigationItem.connected_apps,
        label: 'connected_apps_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.connectedApps}`,
        tenantOnly: true,
        isAvailableFn: isMcpOauthAvailable,
      },
      {
        id: NavigationItem.webhooks,
        label: 'webhooks_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.webhooks}`,
        requiredSecurity: RequiredSecurities.Webhook_Read,
      },
      {
        id: NavigationItem.scim,
        label: 'scim_navigation_item_label',
        routerLink: `/${Api.integrations}/${Api.scim}`,
        requiredSecurity: RequiredSecurities.TI_SCIM_Config_Create,
        featureFlag: FeatureFlagCollection.scimFunctionality,
        isAvailableFn: isSSOAvailable,
      },
      {
        id: NavigationItem.userway,
        label: 'widget',
        routerLink: `/${Api.integrations}/${Api.userway}`,
        requiredSecurity: RequiredSecurities.UserWay_Integration_Read,
        isHiddenFn: isPlatformWidgetTabHidden,
      },
    ],
  },
  {
    id: NavigationItem.administration,
    iconName: Icons.FolderGear,
    label: 'administration',
    group: NavigationGroup.manage,
    children: [
      {
        id: NavigationItem.administration_organizations,
        label: 'tenants',
        requiredSecurity: RequiredSecurities.Tenants_Read,
        tenantlessOnly: true,
        children: [
          {
            id: NavigationItem.administration_my_organizations,
            label: 'my_organizations',
            routerLink: `/${Api.admin}/${Api.organizations}/${Api.my}`,
            requiredSecurity: RequiredSecurities.Tenants_Read,
            tenantlessOnly: true,
            displayedOutsideOfNavbar: true,
          },
          {
            id: NavigationItem.administration_all_organizations,
            label: 'all_organizations',
            routerLink: `/${Api.admin}/${Api.organizations}/${Api.all}`,
            requiredSecurity: RequiredSecurities.Tenants_Read,
            tenantlessOnly: true,
            displayedOutsideOfNavbar: true,
          },
        ],
      },
      {
        id: NavigationItem.administration_users,
        label: 'users',
        requiredSecurity: SecurityUtility.mergeRequiredSecurities([
          RequiredSecurities.Global_Users_Read,
          RequiredSecurities.UM_User_Administration_Read_No_Entity_Level,
        ]),
        children: [
          {
            id: NavigationItem.administration_global_users,
            label: 'global_users',
            routerLink: `/${Api.admin}/${Api.globalUsers}`,
            requiredSecurity: RequiredSecurities.Global_Users_Read,
            tenantlessOnly: true,
            displayedOutsideOfNavbar: true,
          },
          {
            id: NavigationItem.administration_internal_users,
            label: 'internal_users',
            routerLink: `/${Api.admin}/${Api.userManagement}/${Api.internal_users}`,
            requiredSecurity: RequiredSecurities.UM_User_Administration_Read_No_Entity_Level,
            tenantlessOnly: true,
            displayedOutsideOfNavbar: true,
          },
          {
            id: NavigationItem.administration_admin_groups,
            label: 'admin_groups',
            routerLink: `/${Api.admin}/${Api.userGroups}`,
            requiredSecurity: RequiredSecurities.UM_User_Administration_Read_No_Entity_Level,
            tenantlessOnly: true,
            displayedOutsideOfNavbar: true,
          },
        ],
      },
    ],
  },
  {
    id: NavigationItem.internal_use_only,
    iconName: Icons.Gavel,
    label: 'system_maintenance_dropdown_menu_item_label',
    group: NavigationGroup.manage,
    children: [
      {
        id: NavigationItem.master_library,
        label: 'master_library',
        routerLink: `/${Api.admin}/${Api.master_library}`,
        requiredSecurity: RequiredSecurities.Master_Library_Read,
        tenantlessOnly: true,
      },
      {
        id: NavigationItem.active_scans,
        label: 'active_scans_navigation_item_label',
        routerLink: `/${Api.admin}/${Api.active_scans}`,
        requiredSecurity: RequiredSecurities.Admin_Active_Scans_Read,
        tenantlessOnly: true,
      },
      {
        id: NavigationItem.translations,
        label: 'administrator_translations',
        routerLink: `/${Api.admin}/${Api.translations}`,
        requiredSecurity: RequiredSecurities.Translations_Read,
        tenantlessOnly: true,
      },
    ],
  },
  {
    id: NavigationItem.organization_dashboard,
    label: 'organization',
    iconName: Icons.Building,
    context: NavigationContext.tenant,
    children: [
      {
        id: NavigationItem.organization_portfolio,
        label: 'organization_portfolio',
        iconName: Icons.Suitcase,
        context: NavigationContext.tenant,
        group: NavigationGroup.organization,
        requiredSecurity: RequiredSecurities.Organization_Portfolio_Read,
        featureFlag: FeatureFlagCollection.organizationPortfolio,
        routerLink: `/${Api.organization}/${Api.portfolio}`,
      },
      {
        id: NavigationItem.program_dashboard,
        label: 'program_dashboard',
        iconName: Icons.ChartColumn,
        context: NavigationContext.tenant,
        group: NavigationGroup.organization,
        requiredSecurity: RequiredSecurities.GR_Organization_Dashboard_Read,
        routerLink: `/${Api.organization}`,
        aiChatNav: {
          key: 'organization',
          description: 'Organization-level dashboard showing accessibility conformance metrics across the whole organization.',
        },
      },
      {
        id: NavigationItem.program_portfolio,
        label: 'program_portfolio',
        iconName: Icons.Table,
        context: NavigationContext.tenant,
        group: NavigationGroup.organization,
        requiredSecurity: RequiredSecurities.Program_Portfolio_Read,
        featureFlag: FeatureFlagCollection.programPortfolioAssets,
        routerLink: `/${Api.organization}/${Api.programPortfolio}`,
      },
      {
        id: NavigationItem.custom_reports,
        label: 'custom_reports',
        iconName: Icons.FileInvoice,
        context: NavigationContext.tenant,
        group: NavigationGroup.organization,
        requiredSecurity: RequiredSecurities.ReportingAgent_Read_Create_No_Entity_Level,
        featureFlag: FeatureFlagCollection.customReportsPage,
        routerLink: `/${Api.organization}/${Api.custom_reports}`,
        isAvailableFn: ({ isAiEnabled }: INavItemIsAvailableArgs): boolean => isAiEnabled,
      },
      {
        id: NavigationItem.common_findings,
        label: 'common_findings',
        iconName: Icons.DiagramVenn,
        context: NavigationContext.tenant,
        group: NavigationGroup.find_and_fix,
        requiredSecurity: RequiredSecurities.Common_Findings_Read,
        featureFlag: FeatureFlagCollection.commonFindings,
        routerLink: `/${Api.organization}/${Api.commonFindings}`,
      },
    ],
  },
  {
    id: NavigationItem.workspace,
    label: 'sidebar_menu_workspaces', // The workspace dropdown menu items are generated dynamically based on user workspaces
    context: NavigationContext.workspace,
    iconName: Icons.Briefcase,
    mobileModalColorVariant: DsModalColorVariant.LightBlue,
    overrideRouterLink: `/${Api.portfolio}`,
    aiChatNav: {
      key: 'portfolio',
      description: 'List of all digital properties (websites and apps) in the current workspace.',
    },
    children: [
      {
        id: NavigationItem.workspace_dashboard,
        label: 'workspace_dashboard_translation_key',
        iconName: Icons.ChartColumn,
        context: NavigationContext.workspace,
        group: NavigationGroup.workspace,
        requiredSecurity: RequiredSecurities.GR_Governance_Read,
        restrictByWorkspace: true,
        routerLink: `/${Api.overview}`,
        aiChatNav: {
          key: 'overview',
          requiresLinkedPropertyData: true,
          description:
            'Workspace dashboard summarizing accessibility metrics across all digital assets in the current workspace.',
        },
      },
      {
        id: NavigationItem.websites_and_apps,
        label: 'websites_and_apps_translation_key',
        context: NavigationContext.workspace,
        group: NavigationGroup.workspace,
        iconName: Icons.ListUl,
        children: [
          {
            id: NavigationItem.websites_and_apps_portfolio,
            label: 'heading_menu_portfolio', // Never displayed, this is just here to comply with translations to remove warning logs
            context: NavigationContext.workspace,
            routerLink: `/${Api.portfolio}`,
            isHidden: true,
            tenantOnly: true,
          },
          {
            id: NavigationItem.websites_and_apps_overview,
            label: 'overview',
            iconName: Icons.ChartColumn,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.digital_asset,
            requiredSecurity: RequiredSecurities.GR_Dashboard_Read,
            routerLink: `/${Api.dashboard}`,
            aiChatNav: {
              key: 'digitalAssetDashboard',
              requiresLinkedPropertyData: true,
              description:
                'Dashboard for a single digital asset (website or app) showing summary accessibility metrics for that asset only.',
            },
          },
          {
            id: NavigationItem.websites_and_apps_activity,
            label: 'activity_log_page_title',
            badgeLabel: 'notification_label_new',
            iconName: Icons.Clock,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.digital_asset,
            requiredSecurity: RequiredSecurities.GR_Dashboard_Read,
            routerLink: `/${Api.activityLogs}`,
            isAvailableFn: applyIsAvailableFnOnFeatureFlag(
              FeatureFlagCollection.digitalAssetActivityVisibility,
              false,
              (): boolean => true,
            ),
          },
          {
            id: NavigationItem.websites_and_apps_findings,
            label: 'website_and_apps_findings_navigation_item_label',
            iconName: Icons.Bug,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.find_and_fix,
            requiredSecurity: RequiredSecurities.Digital_Asset_Findings_Read,
            routerLink: `/${Api.findings}`,
            aiChatNav: {
              key: 'findings',
              requiresLinkedPropertyData: true,
              description:
                'Use this link when the user asks for a link to accessibility findings or issues for a digital asset. Covers automated findings only (not manual evaluation findings). This is a list view — it cannot deep-link to one specific individual finding.',
            },
            isAvailableFn: isAnyAvailableFn([
              applyIsAvailableFnOnFeatureFlag(FeatureFlagCollection.digitalAssetFindings, false, isWebDpAvailable),
              applyIsAvailableFnOnFeatureFlag(FeatureFlagCollection.daFindingsMobileEnabled, false, isMobileDpAvailable),
            ]),
          },
          {
            id: NavigationItem.my_tasks,
            label: 'digital_asset_tasks_label',
            iconName: Icons.ClipboardList,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.find_and_fix,
            requiredSecurity: RequiredSecurities.PM_Tasks_Read,
            routerLink: `/${Api.websitesAndApps}/${Api.myTasks}`,
            filters: [verticalNavigationFilter(true)],
          },
          {
            id: NavigationItem.websites_and_apps_monitoring,
            label: 'label_monitoring',
            iconName: Icons.MonitorWaveform,
            context: NavigationContext.digitalProperty,
            requiredSecurity: RequiredSecurities.GR_Monitoring_Read,
            routerLink: `/${Api.monitoring}`,
            isAvailableFn: isWebDpAvailable,
            filters: [verticalNavigationFilter(false)],
          },
          {
            id: NavigationItem.websites_and_apps_scans,
            label: 'website_and_apps_scans_navigation_item_label',
            iconName: Icons.Bolt,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.automated_tests,
            isAvailableFn: (args: INavItemIsAvailableArgs): boolean =>
              args.packageName !== PackageNames.Audit && isWebDpAvailable(args),
            children: [
              {
                id: NavigationItem.websites_and_apps_scans_page_scans,
                label: 'scans',
                requiredSecurity: RequiredSecurities.AT_Scans_Read,
                routerLink: `/${Api.websitesAndApps}/${Api.scans}/${Api.page_scans}`,
                aiChatNav: {
                  key: 'scans',
                  requiresLinkedPropertyData: true,
                  description:
                    'List of automated accessibility scans for the current digital asset. Scans are the source of automated findings — use this when the user asks about scans specifically rather than the findings list itself.',
                },
                displayedOutsideOfNavbar: true,
              },
              {
                id: NavigationItem.websites_and_apps_scans_user_flows,
                labelFn: ({ featureFlagService }: INavItemLabelArgs): string =>
                  featureFlagService.variation(FeatureFlagCollection.userFlowsQ42023Revamp, false)
                    ? 'automated_flows'
                    : 'user_flows',
                requiredSecurity: RequiredSecurities.Automated_Flows_Read,
                featureFlag: FeatureFlagCollection.userFlows,
                routerLink: `/${Api.websitesAndApps}/${Api.scans}/${Api.user_flows}`,
                isAvailableFn: isWebDpAvailable,
                displayedOutsideOfNavbar: true,
                filters: [verticalNavigationFilter(false)],
              },
              {
                id: NavigationItem.websites_and_apps_scans_components,
                label: 'match_components',
                requiredSecurity: RequiredSecurities.Component_Matching_Read,
                routerLink: `/${Api.websitesAndApps}/${Api.scans}/${Api.components}`,
                isAvailableFn: isWebDpAvailable,
                displayedOutsideOfNavbar: true,
                filters: [verticalNavigationFilter(false)],
              },
            ],
          },
          {
            id: NavigationItem.websites_and_apps_mobile_scans,
            label: 'website_and_apps_scans_navigation_item_label',
            iconName: Icons.Bolt,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.automated_tests,
            isAvailableFn: (args: INavItemIsAvailableArgs): boolean =>
              args.packageName !== PackageNames.Audit && isMobileDpAvailable(args),
            children: [
              {
                id: NavigationItem.websites_and_apps_mobile_scans_page_scans,
                label: 'mobile_app_scans',
                requiredSecurity: [
                  RequiredSecurities.AT_Mobile_Scans_Read,
                  RequiredSecurities.AT_Mobile_Emulator_Scans_Read,
                  RequiredSecurities.AT_Mobile_Xml_Scans_Read,
                  RequiredSecurities.AT_Mobile_ODT_Scans_Read,
                ],
                routerLink: `/${Api.websitesAndApps}/${Api.mobile_scans}`,
                aiChatNav: {
                  key: 'mobileScans',
                  requiresLinkedPropertyData: true,
                  description: 'List of mobile app scans for the current digital asset.',
                },
                displayedOutsideOfNavbar: true,
              },
            ],
          },
          {
            id: NavigationItem.websites_and_apps_monitoring,
            label: 'label_monitoring',
            iconName: Icons.MonitorWaveform,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.automated_tests,
            requiredSecurity: RequiredSecurities.GR_Monitoring_Read,
            routerLink: `/${Api.monitoring}`,
            aiChatNav: {
              key: 'monitoring',
              requiresLinkedPropertyData: true,
              description:
                'Monitoring overview listing scanned pages and their pass/fail monitoring status for the current digital asset — NOT a list of individual accessibility findings; use the findings link for that.',
            },
            isAvailableFn: isWebDpAvailable,
            filters: [verticalNavigationFilter(true)],
          },
          {
            id: NavigationItem.websites_and_apps_manual_evaluations,
            labelFn: ({ isVerticalNavigationEnabled }: INavItemLabelArgs): string =>
              isVerticalNavigationEnabled ? 'label_manual_evaluations' : 'evaluations_dropdown_menu_item_label',
            iconName: Icons.UserMagnifyingGlass,
            requiredSecurity: RequiredSecurities.MT_Manual_Evaluation_Read,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.expert_audits,
            children: [
              {
                id: NavigationItem.websites_and_apps_manual_evaluations_table,
                label: 'evaluations_dropdown_menu_item_label',
                routerLink: `/${Api.manual_evaluations}`,
                aiChatNav: {
                  key: 'manualEvaluations',
                  requiresLinkedPropertyData: true,
                  description: 'List of manual evaluations for the current digital asset.',
                },
                displayedOutsideOfNavbar: true,
              },
              {
                id: NavigationItem.websites_and_apps_manual_evaluations_requests,
                label: 'evaluations_requests',
                routerLink: `/${Api.manual_evaluations}/${Api.requests}`,
                displayedOutsideOfNavbar: true,
              },
            ],
          },
          {
            id: NavigationItem.websites_and_apps_mobile_manual_evaluations,
            label: 'mobile_manual_evaluations_navigation_item_label',
            iconName: Icons.Mobile,
            requiredSecurity: RequiredSecurities.MT_Mobile_Manual_Evaluations_Read,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.expert_audits,
            routerLink: `/${Api.mobile_manual_evaluations}`,
            isAvailableFn: isFmeFlagOn(FeatureFlagName.mobileManualEvaluations),
          },
          {
            id: NavigationItem.workspace_design_evaluations,
            labelFn: ({ isVerticalNavigationEnabled }: INavItemLabelArgs): string =>
              isVerticalNavigationEnabled ? 'design_evaluations' : 'workspace_design_evaluations_navigation_item_label',
            iconName: Icons.Palette,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.expert_audits,
            routerLink: `/${Api.designEvaluations}`,
            requiredSecurity: RequiredSecurities.DE_Results_Read,
          },
          {
            id: NavigationItem.files,
            label: 'files',
            iconName: Icons.File,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.manage,
            routerLinkFn: (): string => `/${Api.documents}`,
            requiredSecurity: RequiredSecurities.Documents_Read,
            featureFlag: FeatureFlagCollection.moveFilesMenu,
          },
          {
            id: NavigationItem.websites_and_apps_settings_consolidated,
            label: 'digital_asset_settings',
            iconName: Icons.Cog,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.manage,
            filters: [verticalNavigationFilter(true)],
            featureFlag: FeatureFlagCollection.consolidateSettings,
            isAvailableFn: isDigitalAssetSettingsConsolidatedAvailable,
            children: [
              {
                id: NavigationItem.websites_and_apps_settings_monitoring,
                label: 'label_monitoring',
                requiredSecurity: RequiredSecurities.GR_Monitoring_Create_Update,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.monitoringSettings}`,
                isAvailableFn: isWebDpAvailable,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_automated_user_flows,
                labelFn: ({ featureFlagService }: INavItemLabelArgs): string => {
                  if (featureFlagService.variation(FeatureFlagCollection.userFlowsGuided, false)) {
                    return 'automated_user_flows';
                  }

                  return featureFlagService.variation(FeatureFlagCollection.userFlowsQ42023Revamp, false)
                    ? 'automated_flows'
                    : 'user_flows';
                },
                requiredSecurity: RequiredSecurities.Automated_Flows_Read,
                featureFlag: FeatureFlagCollection.userFlows,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.automated_user_flows}`,
                isAvailableFn: isWebDpAvailable,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_guided_user_flows,
                label: 'guided_user_flows',
                requiredSecurity: RequiredSecurities.Automated_Flows_Read,
                featureFlag: FeatureFlagCollection.userFlowsGuided,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.guided_user_flows}`,
                isAvailableFn: isWebDpAvailable,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_settings_components,
                label: 'match_components',
                requiredSecurity: RequiredSecurities.Component_Matching_Read,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.components}`,
                isAvailableFn: isWebDpAvailable,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_settings_environments,
                label: 'environments_label',
                requiredSecurity: RequiredSecurities.Environment_Read,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.environments}`,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_settings_scan_rules,
                label: 'scan_rules_label',
                requiredSecurity: RequiredSecurities.Evaluation_Rules_Read,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.evaluation_rules}`,
                isAvailableFn: isWebDpAvailable,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_settings_scan_tags,
                label: 'scan_tags_label',
                requiredSecurity: RequiredSecurities.Scan_Tags_Read,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.scan_tags}`,
                isAvailableFn: isWebDpAvailable,
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_settings_pages,
                label: 'pages',
                requiredSecurity: RequiredSecurities.Pages_Read,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.pages}`,
                isAvailableFn: (args: INavItemIsAvailableArgs): boolean =>
                  args.packageName !== PackageNames.Audit && isWebDpAvailable(args),
                isHidden: true,
              },
              {
                id: NavigationItem.websites_and_apps_settings_mobile_screens,
                label: 'screens',
                requiredSecurity: RequiredSecurities.AT_Mobile_Scans_Read,
                routerLink: `/${Api.settings}/${Api.digitalAssetSettings}/${Api.mobile_screens}`,
                featureFlag: FeatureFlagCollection.flawMatchingMobile,
                isAvailableFn: (args: INavItemIsAvailableArgs): boolean =>
                  args.packageName !== PackageNames.Audit && isMobileDpAvailable(args),
                isHidden: true,
              },
            ],
          },
          {
            id: NavigationItem.websites_and_apps_settings,
            label: 'digital_asset_settings',
            iconName: Icons.Cog,
            context: NavigationContext.digitalProperty,
            group: NavigationGroup.manage,
            featureFlag: revertFlag(FeatureFlagCollection.consolidateSettings),
            children: [
              {
                id: NavigationItem.websites_and_apps_monitoring_settings,
                label: 'label_monitoring',
                requiredSecurity: RequiredSecurities.GR_Monitoring_Create_Update,
                routerLink: `/${Api.monitoring}/${Api.monitoringSettings}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(
                  `/${Api.monitoring}/${Api.monitoringSettings}`,
                  Api.monitoringSettings,
                ),
                isAvailableFn: isWebDpAvailable,
                filters: [verticalNavigationFilter(true)],
              },
              {
                id: NavigationItem.websites_and_apps_scans_user_flows,
                labelFn: ({ featureFlagService }: INavItemLabelArgs): string =>
                  featureFlagService.variation(FeatureFlagCollection.userFlowsQ42023Revamp, false)
                    ? 'automated_flows'
                    : 'user_flows',
                requiredSecurity: RequiredSecurities.Automated_Flows_Read,
                featureFlag: FeatureFlagCollection.userFlows,
                routerLink: `/${Api.websitesAndApps}/${Api.scans}/${Api.user_flows}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(
                  `/${Api.websitesAndApps}/${Api.scans}/${Api.user_flows}`,
                  Api.automated_user_flows,
                ),
                isAvailableFn: isWebDpAvailable,
                filters: [verticalNavigationFilter(true)],
              },
              {
                id: NavigationItem.websites_and_apps_scans_components,
                label: 'match_components',
                requiredSecurity: RequiredSecurities.Component_Matching_Read,
                routerLink: `/${Api.websitesAndApps}/${Api.scans}/${Api.components}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(
                  `/${Api.websitesAndApps}/${Api.scans}/${Api.components}`,
                  Api.components,
                ),
                isAvailableFn: isWebDpAvailable,
                filters: [verticalNavigationFilter(true)],
              },
              {
                id: NavigationItem.websites_and_apps_environments,
                label: 'environments_label',
                requiredSecurity: RequiredSecurities.Environment_Read,
                routerLink: `/${Api.settings}/${Api.environments}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(`/${Api.settings}/${Api.environments}`, Api.environments),
                iconName: Icons.ChartColumn,
              },
              {
                id: NavigationItem.websites_and_apps_scan_rules,
                label: 'scan_rules_label',
                requiredSecurity: RequiredSecurities.Evaluation_Rules_Read,
                routerLink: `/${Api.settings}/${Api.evaluation_rules}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(`/${Api.settings}/${Api.evaluation_rules}`, Api.evaluation_rules),
                isAvailableFn: isWebDpAvailable,
              },
              {
                id: NavigationItem.websites_and_apps_scan_tags,
                label: 'scan_tags_label',
                requiredSecurity: RequiredSecurities.Scan_Tags_Read,
                routerLink: `/${Api.settings}/${Api.scan_tags}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(`/${Api.settings}/${Api.scan_tags}`, Api.scan_tags),
                isAvailableFn: isWebDpAvailable,
              },
              {
                id: NavigationItem.websites_and_apps_pages,
                label: 'pages',
                requiredSecurity: RequiredSecurities.Pages_Read,
                routerLink: `/${Api.pages}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(`/${Api.pages}`, Api.pages),
                isAvailableFn: (args: INavItemIsAvailableArgs): boolean =>
                  args.packageName !== PackageNames.Audit && isWebDpAvailable(args),
              },
              {
                id: NavigationItem.websites_and_apps_mobile_screens,
                label: 'screens',
                requiredSecurity: RequiredSecurities.AT_Mobile_Scans_Read,
                routerLink: `/${Api.mobile_screens}`,
                routerLinkFn: digitalAssetSettingsRouterLinkFn(`/${Api.mobile_screens}`, Api.mobile_screens),
                featureFlag: FeatureFlagCollection.flawMatchingMobile,
                isAvailableFn: (args: INavItemIsAvailableArgs): boolean =>
                  args.packageName !== PackageNames.Audit && isMobileDpAvailable(args),
              },
            ],
          },
        ],
      },
      {
        id: NavigationItem.pdf,
        label: 'pdf_navigation_item_label',
        ariaLabel: 'pdf_navigation_item_aria_label',
        iconName: Icons.FilePdf,
        context: NavigationContext.workspace,
        routerLink: `/${Api.scannableDocuments}`,
        requiredSecurity: RequiredSecurities.PDF_Testing_Read,
        filters: [verticalNavigationFilter(false)],
      },
      {
        id: NavigationItem.projects_and_tasks,
        context: NavigationContext.workspace,
        group: NavigationGroup.find_and_fix,
        labelFn: ({ isVerticalNavigationEnabled }: INavItemLabelArgs): string =>
          isVerticalNavigationEnabled ? 'label_projects_and_tasks' : 'projects_and_tasks',
        iconName: Icons.ClipboardList,
        children: [
          {
            id: NavigationItem.projects,
            label: 'projects',
            requiredSecurity: RequiredSecurities.PM_Projects_Read,
            routerLink: `/${Api.projects}`,
            displayedOutsideOfNavbar: true,
          },
          {
            id: NavigationItem.my_tasks,
            label: 'my_tasks_label',
            requiredSecurity: RequiredSecurities.PM_Tasks_Read,
            routerLink: `/${Api.myTasks}`,
            displayedOutsideOfNavbar: true,
          },
        ],
      },
      {
        id: NavigationItem.pdf,
        label: 'pdf_navigation_item_label',
        ariaLabel: 'pdf_navigation_item_aria_label',
        iconName: Icons.FilePdf,
        context: NavigationContext.workspace,
        group: NavigationGroup.find_and_fix,
        routerLink: `/${Api.scannableDocuments}`,
        requiredSecurity: RequiredSecurities.PDF_Testing_Read,
        filters: [verticalNavigationFilter(true)],
      },
      {
        id: NavigationItem.files,
        label: 'files',
        iconName: Icons.File,
        context: NavigationContext.workspace,
        group: NavigationGroup.manage,
        routerLink: `/${Api.documents}`,
        requiredSecurity: RequiredSecurities.Documents_Read,
        featureFlag: revertFlag(FeatureFlagCollection.moveFilesMenu),
      },
      {
        id: NavigationItem.workspace_settings_consolidated,
        label: 'workspace_settings',
        iconName: Icons.Cog,
        context: NavigationContext.workspace,
        group: NavigationGroup.manage,
        filters: [verticalNavigationFilter(true)],
        featureFlag: FeatureFlagCollection.consolidateSettings,
        routerLink: `/${Api.overview}/${Api.workspaceSettings}`,
      },
      {
        id: NavigationItem.workspace_settings,
        label: 'workspace_settings',
        iconName: Icons.Cog,
        context: NavigationContext.workspace,
        group: NavigationGroup.manage,
        filters: [verticalNavigationFilter(true)],
        featureFlag: revertFlag(FeatureFlagCollection.consolidateSettings),
        children: [
          {
            id: NavigationItem.workspace_policies,
            label: 'policies',
            requiredSecurity: RequiredSecurities.GR_Governance_Create,
            routerLink: `/${Api.overview}/${Api.accessibilityPolicies}`,
          },
          {
            id: NavigationItem.workspace_details,
            label: 'label_workspace_details',
            requiredSecurity: RequiredSecurities.Workspaces_Update,
            restrictByWorkspace: true,
            routerLinkFn: ({ queryParams }: INavItemRouterLinkArgs): string => {
              const { workspaceId } = LinkedPropertyUtility.fromLinkedPropertyQueryParam(queryParams);
              return `/${Api.portfolio}/${workspaceId}/${Api.edit}`;
            },
          },
        ],
      },
    ],
  },
  {
    id: NavigationItem.profile,
    label: 'profile_details',
    routerLink: `/${Api.settings}/${Api.profile}`,
    iconName: Icons.User,
  },
  {
    id: NavigationItem.nav_switch,
    label: 'nav_switch',
    iconName: Icons.ListUl,
  },
  {
    id: NavigationItem.logout,
    label: 'logout',
    routerLink: `/${Api.logout}`,
    iconName: Icons.ArrowRightFromBracket,
  },
  {
    id: NavigationItem.notifications,
    label: 'notifications',
    routerLink: `/${Api.notifications}`,
    iconName: Icons.Bell,
    requiredSecurity: RequiredSecurities.Notifications_Read,
  },
  {
    id: NavigationItem.level_ci,
    label: 'level_ci',
    group: NavigationGroup.support,
    iconName: Icons.LevelDevCi,
    featureFlag: FeatureFlagCollection.enableLevelCI,
    externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getLevelCiUrl(),
  },
  {
    id: NavigationItem.academy,
    label: 'academy',
    iconName: Icons.GraduationCap,
    group: NavigationGroup.support,
    requiredSecurity: RequiredSecurities.Academy_Read,
    external: true,
    isAvailableFn: ({ isAcademyAvailable }: INavItemIsAvailableArgs): boolean => isAcademyAvailable,
    onClickFn:
      ({ academyService }: INavItemOnClickArgs) =>
      () => {
        academyService.subscribeForSsoLink();
      },
  },
  {
    id: NavigationItem.old_help,
    label: 'label_help',
    iconName: Icons.CircleQuestion,
    children: [
      {
        id: NavigationItem.help_submit_ticket,
        label: 'label_help_submit_ticket',
        iconName: Icons.MessagesQuestion,
        externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getZendeskSubmitTicketUrl(),
      },
      {
        id: NavigationItem.help_search_knowledge,
        label: 'label_help_search_knowledge',
        iconName: Icons.Book,
        externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getHelpCenterUrl(),
      },
    ],
  },
  {
    id: NavigationItem.help,
    label: 'label_help',
    iconName: Icons.CircleQuestion,
    group: NavigationGroup.support,
    children: [
      {
        id: NavigationItem.help_product_support,
        label: 'product_support',
        iconName: Icons.MessagesQuestion,
        externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getProductSupportFormUrl(),
      },
      {
        id: NavigationItem.help_help_center,
        label: 'help_center',
        iconName: Icons.Book,
        externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getHelpCenterUrl(),
      },
      {
        id: NavigationItem.help_submit_feedback,
        label: 'submit_feedback',
        iconName: Icons.Map,
        externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getProductFeedbackUrl(),
      },
    ],
  },
  {
    id: NavigationItem.service_request,
    labelFn: ({ isVerticalNavigationEnabled }: INavItemLabelArgs): string =>
      isVerticalNavigationEnabled ? 'service_requests' : 'request_a_service',
    iconName: Icons.MessageArrowUpRight,
    group: NavigationGroup.support,
    children: [
      // TODO: EAP-30837 Re-add the item once the requirements are returned by the product team.
      // {
      //   id: NavigationItem.service_request_email_consultation,
      //   label: 'email_consultation',
      //   iconName: Icons.UniversalAccess,
      //   externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getEmailConsultationFormUrl(),
      // },
      {
        id: NavigationItem.service_request_manual_evaluation,
        label: 'manual_evaluation',
        iconName: Icons.FileMagnifyingGlass,
        externalLinkFn: (externalLinkService: ExternalLinkService) =>
          externalLinkService.getManualEvaluationServiceRequestFormUrl(),
      },
      {
        id: NavigationItem.service_request_validation_testing,
        label: 'validation_testing',
        iconName: Icons.MessageCheck,
        externalLinkFn: (externalLinkService: ExternalLinkService) =>
          externalLinkService.getValidationTestingServiceRequestFormUrl(),
      },
      {
        id: NavigationItem.service_request_cuet_evaluation,
        label: 'cuet_evaluation',
        iconName: Icons.MicrochipAi,
        routerLink: `/${Api.cuet_evaluations}`,
        featureFlag: FeatureFlagCollection.cuetEvaluations,
      },
      {
        id: NavigationItem.service_request_view_all_services,
        label: 'view_all_services',
        externalLinkFn: (externalLinkService: ExternalLinkService) => externalLinkService.getZendeskSubmitTicketUrl(),
      },
    ],
  },
]);
